export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_SIRE_5.8de80dab.jpg";